// src/data/employees.js
import p11 from './p11.jpg';
import p12 from './p12.jpg';
import p13 from './p13.jpg';
import p21 from './p21.jpg';
import p22 from './p22.jpg';
import p23 from './p23.jpg';
import p31 from './p31.jpg';
import p41 from './p41.jpg';
import p42 from './p42.jpg';
import p43 from './p43.jpg';
import p51 from './p51.jpg';
import p52 from './p52.jpg';
import p53 from './p53.jpg';
import p61 from './p61.jpg';
import p62 from './p62.jpg';
import p63 from './p63.jpg';
import p71 from './p71.jpg';
import p72 from './p72.jpg';
import p73 from './p73.jpg';
import p81 from './p81.jpg';
import p82 from './p82.jpg';
import p91 from './p91.jpg';
import p92 from './p92.jpg';
import p93 from './p93.jpg';
import p101 from './p101.jpg';

const employees = [
  {
    id: '1',
    name: 'Lili',
    age: 22,
    location: 'Markham',
    images: [p12, p11, p13],
    height: '163cm',
    weight: '45KG',
    measurement: '34D',
    services: 'SF2, DFK, 69, bbbj, cim, rim, kiss, nuru',
    rates: `30/160   60/240   nuru 60/300   90/340`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
    // introduction: `性感神秘的野貓
    //   身高163公分，34D，
    //   前凸后翘，皮肤光滑雪白，一双细长美腿让你爱不释手。
    //   资深港式专业按摩师，針對各种痛症，肩周炎，坐骨神經，颈椎劳损，头痛失眠。大师级前列腺保養高手，針對前列腺增生肥大，性欲減弱有很大改善，蜜心Nuru啫喱挑情专家，令你有欲仙欲死都难形容的感觉，一试情难自禁，永生难忘
    //   30分钟全套$160
    //   按摩加全套60分钟220
    //   NUru情趣按摩加半套45分钟200
    //   Nuru情趣按摩加半套60分钟$220
    //   Nuru按摩加全套70分钟$300
    //   採耳按摩加全套90分鐘300
    //   耳烛按摩加半套90分鐘260`,
    introduction: `Professional massager from Hongkong. Specialized in earwax treatment, lymphatic detox massage, relieves fatigue and mental stress, improves sleep quality.,
`
  },
  {
    id: '2',
    name: 'Apple',
    age: 21,
    location: 'Richmond Hill',
    images: [p23, p22, p21],
    height: '158cm',
    weight: '48KG',
    measurement: '34C',
    services: 'SF2, DFK, 69, bbbj, cim, rim, kiss, nuru',
    rates: `30/160   60/240   nuru 60/300   90/340`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
    introduction: `
      Sweet and innocent appearance with a passionate and adventurous heart. Very cooperative, with a gentle and graceful personality. Her sweet smile and charming dimples will leave you wanting more and reluctant to leave!
      `,
  },
  {
    id: '3',
    name: 'CiCi',
    age: 22,
    location: 'Markham',
    images: [p31],
    height: '160cm',
    weight: '50KG',
    measurement: '36D',
    services: 'SF2, DFK, 69, bbbj, cim, rim, kiss, nuru',
    rates: `30/160   60/240   nuru 60/300   90/340`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
    // introduction: `
    // 刚来的南方女孩，温柔可人肌肤白嫩丝滑，女朋友的experience,情绪价值拉满，期待小哥哥的甜蜜约会100%的配合度
    // 160/30分钟，220/45分钟，300/60分钟（2次）
    // `,
    introduction: `
    Gentle and sweet, with fair and smooth skin. Girlfriend experience, full emotional engagement, looking forward to a sweet date with you, handsome, with 100% cooperation.`,
  },
  {
    id: '4',
    name: 'AiBi',
    age: 20,
    location: 'Markham',
    images: [p41, p42, p43],
    height: '158cm',
    weight: '48KG',
    measurement: '36D',
    services: 'DFK, 69, bbbj, cim, rim, kiss, nuru',
    rates: `30/160   60/240   nuru 60/300   90/340`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
    // introduction: `制服丝袜，高跟鞋诱惑
    //   服务: 口活流，旋转调情高手
    //   舌吻，鸳鸯浴，波D，环保吹，旋转舔蛋，深喉，全身漫游，六九互舔，口爆，指滑，
    //   服务价格?
    //   160/30min
    //   220/60min
    //   360/90min`,
    introduction: `Uniform stockings, high heels temptation, Expert in oral skills`,
  },
  {
    id: '6',
    name: 'Lisa',
    age: 20,
    location: 'Markham',
    images: [p61, p62, p63],
    height: '158cm',
    weight: '60KG',
    measurement: '36E',
    services: 'DFK, 69, bbbj, cim, rim, kiss, nuru',
    rates: `30/160   60/240   nuru 60/300   90/340`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
  //   introduction: `160$30分鐘/45分鐘220$/60分鐘300可2s
  //   「持久戰90分鐘潮吹送口爆400$保證潮吹」

  //   服務內容：共浴，水萧，胸推、乳交、冰火,指滑、事後瀟、（口爆+40）
  //   請提前2小時預約！如果電話沒接就是在忙 , 請發信息, 我看到會回覆喔～
  //   潮吹台妹，可愛豐滿，个性开朗活泼，待客真诚，净高160cm，天然真胸36E超爽手感，反應敏感自然，配合度高，服務應有盡有，吹功一流！服務態度極佳保證讓您滿意～歡迎來挑戰❤️
  //   「不做無套後花園免問」`,
  // },
    introduction: `Squirting Taiwanese girl, cute and plumpy. All natural 36E breasts with a super pleasant touch. Special: 90 mins squirting show, please make an appointment in advance!`,
  },
  {
    id: '5',
    name: 'Coco',
    age: 24,
    location: 'Markham',
    images: [p51, p52, p53],
    height: '166cm',
    weight: '60KG',
    measurement: '36C',
    services: 'DFK, kiss, massage',
    rates: `30/160   60/240 `,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
    // introduction: `
    //   资深按摩师，针对腰肌痨损，疏通经络，穴位精准，独门抓龙筋，前列腺保健，真正防止前列腺肥大增生，搞高性欲持久，享受完全释放和前所未有的畅快真正让你享受身心释放，身心健康
    //   按摩加半套前列腺保健70分钟190
    //   按摩加半套前列腺保健加耳烛100分钟/260
    //   黄金组合按摩加全套90分钟/300（全套由室友小妹）
    //   按摩加半套丝袜足交70分钟/220
    //   深层淋巴排毒加半套100分钟 /260`,
    introduction: `Experienced massage therapist specializing in lumbar muscle strain, meridian therapy, and precise acupoint treatment. Unique ‘dragon tendon’ technique, prostate care to genuinely prevent prostate enlargement and hyperplasia, enhance libido and stamina, and provide complete physical and emotional release like never before — truly allowing you to enjoy both physical and mental wellness.

`,
  },
//   {
//     id: '7',
//     name: 'Lena',
//     age: 20,
//     location: 'Markham',
//     images: [p71, p72, p73],
//     height: '160cm',
//     weight: '45KG',
//     measurement: '34D',
//     services: 'DFK, 69, bbbj, cim, rim, kiss, nuru',
//     rates: `30/160   45/220  60/300  90/400 (cim rim included)`,
//     workHours: '10:00/11:00',
//     address: 'hwy7/Times',
//     phone: '437-216-6181',
// //     introduction: `温柔体贴，身材好，皮肤好，
// // 全套服务：
// // 莞柔点指、前列腺高潮开发，尽享与众不同的身心愉悦轻松、让丁丁享受这种快感，让它适应这种刺激和敏
// // 抚摸陪浴，香乳游离，果漫后花园，耳漫，丝足，69互舔，冰火两重天，胸推，臀推，阴推，nuru情趣按摩，要有尽有，前.后.抱起来啪啪都是爽到爆，配合度极高，`,
//     introduction: ` Gentle and caring, great figure, smooth skin.
//     Full service includes:
//     Gentle fingertip stimulation, prostate climax development, enjoy a unique physical and mental pleasure, allowing your little buddy to experience this sensation, getting used to this stimulation and sensitivity.
//     Bathing with caressing, fragrant breast play, playful backdoor garden, ear massage, silk foot job,
//     69 mutual licking, ice and fire dual sensations, breast push, buttock push,
//     vaginal push, Nuru sensual massage, everything you desire. Front and back cuddling and
//     passionate encounters are all explosively pleasurable, with extremely high cooperation level.`,
//   },
//   {
//     id: '8',
//     name: 'Mina',
//     age: 20,
//     location: 'Markham',
//     images: [p81, p82],
//     height: '158cm',
//     weight: '40KG',
//     measurement: '36D',
//     services: 'DFK, 69, bbbj, cim, rim, nuru massage',
//     rates: `30/160   45/220  60/300  90/400 (cim rim included)`,
//     workHours: '10:00/11:00',
//     address: 'hwy7/Times',
//     phone: '437-216-6181',
// //     introduction: `温柔体贴，身材好，皮肤好，
// // 全套服务：
// // 莞柔点指、前列腺高潮开发，尽享与众不同的身心愉悦轻松、让丁丁享受这种快感，让它适应这种刺激和敏
// // 抚摸陪浴，香乳游离，果漫后花园，耳漫，丝足，69互舔，冰火两重天，胸推，臀推，阴推，nuru情趣按摩，要有尽有，前.后.抱起来啪啪都是爽到爆，配合度极高，`,
//     introduction: `A seasoned Thai massage therapist, specializing in acupressure, oil massage, and a range of techniques to effectively relieve stress and fatigue.`,
//   },
  {
    id: '9',
    name: 'Summer',
    age: 20,
    location: 'Richmond Hill',
    images: [p91, p92, p93],
    height: '163cm',
    weight: '45KG',
    measurement: '36D',
    services: 'DFK, 69, bbbj, cim, rim, nuru massage',
    rates: `30/220   60/400`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
//     introduction: `温柔体贴，身材好，皮肤好，
// 全套服务：
// 莞柔点指、前列腺高潮开发，尽享与众不同的身心愉悦轻松、让丁丁享受这种快感，让它适应这种刺激和敏
// 抚摸陪浴，香乳游离，果漫后花园，耳漫，丝足，69互舔，冰火两重天，胸推，臀推，阴推，nuru情趣按摩，要有尽有，前.后.抱起来啪啪都是爽到爆，配合度极高，`,
    introduction: `Part-time student on site. White skin, great figure, smooth skin. Limited time only.`,
  },
  {
    id: '10',
    name: 'Yumi',
    age: 20,
    location: 'Markham',
    images: [p101],
    height: '158cm',
    weight: '40KG',
    measurement: '36D',
    services: 'DFK, 69, bbbj, cim, rim, nuru massage',
    rates: `30/160   45/220  60/300  90/400 (cim rim included)`,
    workHours: '10:00/11:00',
    address: 'hwy7/Times',
    phone: '437-216-6181',
//     introduction: `温柔体贴，身材好，皮肤好，
// 全套服务：
// 莞柔点指、前列腺高潮开发，尽享与众不同的身心愉悦轻松、让丁丁享受这种快感，让它适应这种刺激和敏
// 抚摸陪浴，香乳游离，果漫后花园，耳漫，丝足，69互舔，冰火两重天，胸推，臀推，阴推，nuru情趣按摩，要有尽有，前.后.抱起来啪啪都是爽到爆，配合度极高，`,
    introduction: `Young and Beautiful.`,
  },
];

// const employees = [
//   {
//     id: '1',
//     name: 'Vivi',
//     age: 22,
//     location: 'Markham',
//     images: [alice1, alice2],
//     introduction: `私做沐菲
// 身高158cm体重
// 48KG天然酥胸34c
// 服务极至到位，乖乖的外表熱情奔放的內心，配合度极高，性格温婉大方，甜美的笑容迷人的小酒窩讓你流連忘返！服务:水中萧，69，DFK，胸推，漫游 ，划指，冰火，口沙，拨罐，毒龙，口爆，品鲍，事後蕭，至尊女友式享受
// 全套30/160
// 按摩加全套60/240
// 莞式一条龙90/340（可2次）
// 地址7hwy/Times
// 电话:437-998-3816
// 工作时.间:10:00/11:00
// （无套爱爱和后花园免问）
// 【真人照片】`
//   },
//   {
//     id: '2',
//     name: 'Kayo',
//     age: 19,
//     location: 'Markham',
//     images: [bob1, bob2],
//     introduction1: `私做按摩GiGi
// 性感神秘的野貓Gig
// 身高163公分，34D，
// 前凸后翘，皮肤光滑雪白，一双细长美腿让你爱不释手。
// 资深港式专业按摩师，針對各种痛症，肩周炎，坐骨神經，颈椎劳损，头痛失眠。大师级前列腺保養高手，針對前列腺增生肥大，性欲減弱有很大改善，蜜心Nuru啫喱挑情专家，令你有欲仙欲死都难形容的感觉，一试情难自禁，永生难忘
// 30分钟全套$160
// 按摩加全套60分钟220
// NUru情趣按摩加半套45分钟200
// Nuru情趣按摩加半套60分钟$220
// Nuru按摩加全套70分钟$300
// 採耳按摩加全套90分鐘300
// 耳烛按摩加半套90分鐘260
// 欢迎电话预约
// 地址: hwy7 / warden Ave.
// 电话号码437-332-8628
// 没电话号码的不接喔～
// 【真人照片】`,
//     introduction2: `私做唯一
// 價格：
// 160$30分鐘/45分鐘220$/60分鐘300可2s
// 「持久戰90分鐘潮吹送口爆400$保證潮吹」
// 另有半套服務：30分鐘120/60分鐘180$
// 服務內容：共浴，水萧，胸推、乳交、冰火,指滑、事後瀟、（口爆+40）
// 地址 warden / hwy7
// 上班時間：上午11:30至晚上11:00
// 電話 437-876-9262
// 請提前2小時預約！如果電話沒接就是在忙 , 請發信息, 我看到會回覆喔～
// 潮吹台妹，可愛豐滿，个性开朗活泼，待客真诚，净高160cm，天然真胸36E超爽手感，反應敏感自然，配合度高，服務應有盡有，吹功一流！服務態度極佳保證讓您滿意～歡迎來挑戰❤️
// 「不做無套後花園免問」`
//   }
// ];

export default employees;